export const environment = {
    production: false,
    apiUrl: 'https://dev-api.montage-connect.com/deviceservice/api',
    otaUrl: 'https://dev-api.montage-connect.com/api',
    userServiceUrl: 'https://dev-api.montage-connect.com/userservice/api',
    logoutUrl: 'https://login.microsoftonline.com/{tenant}/oauth2/logout',
    ssoUrl: 'https://dev-api.montage-connect.com/oauth2/authorization/azure',
    ssoCookieDomain: '.montage-connect.com',
    
  };
  